import styled from 'styled-components'

import { Flex } from 'Components/UI/_Legacy'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_INLINE_PADDINGS, PY_BLUEPRINT } from 'Constants/Landing'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled(Flex).attrs({
  my: PY_BLUEPRINT,
  px: LANDING_INLINE_PADDINGS,
})`
  width: 100%;
  justify-content: center;
`

export const Content = styled(Flex)
  .attrs({
    flexDirection: ['column', 'row'],
  })
  .withConfig({
    shouldForwardProp,
  })``

export const LeftSide = styled(Flex)
  .attrs({
    width: [1, 60 / 118],
  })
  .withConfig({
    shouldForwardProp,
  })`
  padding-right: 20px;
`

export const ImageHolder = styled(Flex)
  .attrs({
    width: [1, 58 / 118],
    mt: [20, 0],
    height: [240, 240, 234, 314, 430],
  })
  .withConfig({
    shouldForwardProp,
  })`
  justify-content: center;
  position: relative;
`
